import { BehaviorSubject, Observable } from "rxjs";

import { EveReportingWidgetDataSource } from "../../components/widgets/widget-menu-settings/widget-datasource/widget-datasource.component";
import { EveReportingWidget } from "../../components/widgets/widget.component";
import { Multi } from "../../interfaces/multi.interface";
import { Single } from "../../interfaces/single.interface";


export abstract class IDataSourceService {

  abstract MultiResults(eveReportingWidget: BehaviorSubject<EveReportingWidget>, staticData: Multi[]): Observable<Multi[]>;
  abstract SingleResults(eveReportingWidget: BehaviorSubject<EveReportingWidget>, staticData: Single[]): Observable<Single[]>;

}

export interface iDataSource {
  dataSource: EveReportingWidgetDataSource
}
